module.exports = __webpack_public_path__ + "img/blank.4ba9a956.png";